/* ==========================================================================
   Hero Slider JS — Aaram by SS
   Loaded with `defer`, so it never blocks HTML parsing or first paint.
   Only swaps CSS classes — never touches image src, so it can't trigger
   any extra network requests or re-layout.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    var slides = root.querySelectorAll('.hero-slider__slide');
    var dots = root.querySelectorAll('.hero-slider__dot');
    if (slides.length <= 1) return;

    var current = 0;
    var autoplayMs = 5000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function startAutoplay() {
      stopAutoplay();
      timer = window.setInterval(next, autoplayMs);
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay(); // reset timer on manual interaction
      });
    });

    // Pause when tab isn't visible — saves battery/CPU, avoids jumps on return
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    startAutoplay();
  });
});
